import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	snippetEditorModalTitleCreate: {
		id: 'snippets.snippetEditorModal.titleCreate',
		defaultMessage: 'Create block template',
		description: 'Title for the create block template modal',
	},
	snippetEditorModalCreateDescription: {
		id: 'snippets.snippetEditorModal.createDescription',
		defaultMessage: 'Save content and easily reuse it through / menu.',
		description: 'Description for the create template modal',
	},
	snippetEditorModalTitleEdit: {
		id: 'snippets.snippetEditorModal.titleEdit',
		defaultMessage: 'Edit block template',
		description: 'Title for the edit block template modal',
	},
	snippetEditorModalNameLabel: {
		id: 'snippets.snippetEditorModal.nameLabel',
		defaultMessage: 'Template Name',
		description: 'Label for the template name input',
	},
	snippetEditorModalNamePlaceholder: {
		id: 'snippets.snippetEditorModal.namePlaceholder',
		defaultMessage: 'Enter template name',
		description: 'Placeholder for the template name input',
	},
	snippetEditorModalNameError: {
		id: 'snippets.snippetEditorModal.nameError',
		defaultMessage: 'Name is required',
		description: 'Error message for the template name input',
	},
	snippetEditorModalDescriptionLabel: {
		id: 'snippets.snippetEditorModal.descriptionLabel',
		defaultMessage: 'Description',
		description: 'Description label for the modal',
	},
	snippetEditorModalDescriptionPlaceholder: {
		id: 'snippets.snippetEditorModal.descriptionPlaceholder',
		defaultMessage: 'Enter template description',
		description: 'Placeholder for the description input',
	},
	snippetEditorModalAdfError: {
		id: 'snippets.snippetEditorModal.adfError',
		defaultMessage: 'Something went wrong, please make a new content selection',
		description: 'Error message for when the selected ADF is invalid',
	},
	snippetEditorModalCancelButton: {
		id: 'snippets.snippetEditorModal.cancelButton',
		defaultMessage: 'Cancel',
		description: 'Cancel button text',
	},
	snippetEditorModalCreateButton: {
		id: 'snippets.snippetEditorModal.createButton',
		defaultMessage: 'Create',
		description: 'Create button text for create mode',
	},
	snippetEditorModalSaveButton: {
		id: 'snippets.snippetEditorModal.saveButton',
		defaultMessage: 'Save',
		description: 'Save button text for edit mode',
	},
	snippetEditorModalEditSuccessFlagTitle: {
		id: 'snippets.snippetEditorModal.editSuccessFlagTitle',
		defaultMessage: 'Template "{snippetName}" updated',
		description: 'Success flag title shown when a block template has been updated',
	},
	snippetEditorModalEditErrorFlagTitle: {
		id: 'snippets.snippetEditorModal.editErrorFlagTitle',
		defaultMessage: 'Could not update the template',
		description: 'Error flag title shown when a block template update fails',
	},
	snippetEditorModalEditErrorFlagDescription: {
		id: 'snippets.snippetEditorModal.editErrorFlagDescription',
		defaultMessage: 'Please try again',
		description: 'Error flag description shown when a block template update fails',
	},
	snippetEditorModalSuccessFlagTitle: {
		id: 'snippets.snippetEditorModal.successFlagTitle',
		defaultMessage: 'Template "{snippetName}" created',
		description: 'Title for the success flag shown when template creation succeeds',
	},
	snippetEditorModalSuccessFlagDescription: {
		id: 'snippets.snippetEditorModal.successFlagDescription',
		defaultMessage: 'You can now use it from the / menu',
		description: 'Description for the success flag shown when template creation succeeds',
	},
	snippetEditorModalErrorFlagTitle: {
		id: 'snippets.snippetEditorModal.errorFlagTitle',
		defaultMessage: 'Could not create template',
		description: 'Title for the error flag shown when template creation fails',
	},
	snippetEditorModalErrorFlagDescription: {
		id: 'snippets.snippetEditorModal.errorFlagDescription',
		defaultMessage: 'Please try again',
		description: 'Description for the error flag shown when template creation fails',
	},
});
